// @tenorlab/nuxt-dashboard-pro
// file: app/models/navigation/menuItemIds.ts
export const menuItemIds = Object.freeze({
  home: 'home',
  about: 'about',
  anotherpage: 'anotherpage',
  dashboards: 'dashboards',
  dashboardReadonly: 'dashboard-readonly',
} as const)

export type TNavigationItemKey = keyof typeof menuItemIds
export type TNavigationItemId = (typeof menuItemIds)[keyof typeof menuItemIds]
